import { getFeedbackStatusLabel } from './feedbackLabels';
import { getUtilityBookingStatusLabel } from './bookingStatusLabels';

type TranslateFn = (key: string) => string;
type Lang = 'vi' | 'en';

const GENERIC_STATUS_KEYS: Record<string, string> = {
  PENDING: 'taskStatusPending',
  PAID: 'statusPaid',
  OVERDUE: 'statusOverdue',
  UNPAID: 'statusUnpaid',
};

const STATUS_COLORS: Record<string, string> = {
  PENDING: 'text-yellow-600 bg-yellow-100',
  PENDING_CONFIRMATION: 'text-yellow-600 bg-yellow-100',
  CONFIRMED: 'text-green-600 bg-green-100',
  IN_PROGRESS: 'text-blue-600 bg-blue-100',
  COMPLETED: 'text-green-600 bg-green-100',
  REJECTED: 'text-red-600 bg-red-100',
  CANCELLED: 'text-red-600 bg-red-100',
  DEPOSIT_COLLECTED: 'text-cyan-600 bg-cyan-100',
  DEPOSIT_REFUNDED: 'text-indigo-600 bg-indigo-100',
  AWAITING_COMPLETION: 'text-blue-600 bg-blue-100',
  PENDING_CANCELLATION: 'text-orange-600 bg-orange-100',
  PAID: 'text-green-600 bg-green-100',
  OVERDUE: 'text-red-600 bg-red-100',
  UNPAID: 'text-yellow-600 bg-yellow-100',
};

export function getDisplayStatusLabel(status: string, t: TranslateFn, lang: Lang = 'vi'): string {
  const normalized = status.toUpperCase();

  const feedbackLabel = getFeedbackStatusLabel(normalized, t);
  if (feedbackLabel !== normalized) {
    return feedbackLabel;
  }

  const bookingLabel = getUtilityBookingStatusLabel(normalized, lang);
  if (bookingLabel !== normalized) {
    return bookingLabel;
  }

  const genericKey = GENERIC_STATUS_KEYS[normalized];
  if (genericKey) {
    return t(genericKey);
  }

  return status;
}

export function getDisplayStatusColor(status: string): string {
  return STATUS_COLORS[status.toUpperCase()] || 'text-gray-600 bg-gray-100';
}
